import { sqWorkbookStore } from '@/core/core.stores';
import { useFluxPaths } from '@/core/hooks/useFluxPaths.hook';
import type { WorkbookApprovalFlowStep } from '@/worksheet/worksheet.types';

export const useApprovalFlows = () => {
  const {
    approvalFlows,
    approvalFlowAssignments,
    approvalFlowAttachments,
    workbookId,
    effectivePermissions,
    isAnalysis,
    isArchived,
  } = useFluxPaths(sqWorkbookStore, [
    'approvalFlows',
    'approvalFlowAssignments',
    'approvalFlowAttachments',
    'workbookId',
    'effectivePermissions',
    'isAnalysis',
    'isArchived',
  ]);
  // Initial implementation assumes there would only 1 approvalFlows per server.
  const approvalFlow = approvalFlows[0];
  const pendingApprovalSteps = approvalFlow?.steps?.filter(
    ({ status }: WorkbookApprovalFlowStep) => status === 'PENDING',
  );
  const approvedSteps = approvalFlow?.steps?.filter(({ status }: WorkbookApprovalFlowStep) => status === 'APPROVED');
  const nextStep = pendingApprovalSteps?.[0];
  const hasAccessToAnyStep =
    approvalFlow?.steps.some(
      (step) => !step.archived && Object.entries(step.permissions).reduce((res, [, value]) => res || value, false),
    ) ?? false;
  const showApplyBtn =
    Boolean(approvalFlow) &&
    isAnalysis &&
    !isArchived &&
    effectivePermissions.manage &&
    !approvalFlowAttachments.length;
  const showStepDropdown = Boolean(approvalFlow) && isAnalysis && !isArchived && hasAccessToAnyStep;

  return {
    approvedSteps,
    pendingApprovalSteps,
    approvalFlow,
    approvalFlowAssignments,
    hasAccessToAnyStep,
    nextStep,
    showApplyBtn,
    showStepDropdown,
    workbookId,
  };
};
